import Api from 'utils/ApiRequest'
import API_TOTEM from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_TOTEM_REPORTS_REQUEST,
  FETCH_TOTEM_REPORTS_SUCCESS,
  FETCH_TOTEM_REPORTS_ERROR,
} from 'actionTypes'

/*
 * REQUEST TOTEM REPORT FILTER
 */
export const fetchTotemReports = (token, filters) => (dispatch) => {
  dispatch(fetchTotemReportsRequest())

  const params = {
    ...filters,
  }

  return new Api(token, dispatch)
    .post(API_TOTEM.TOTEM_FILTER_REPORTS, params)
    .then(dispatch(showSpinner()))
    .then(
      (response) => {
        fetchTotemReportsSuccess(response.data, dispatch)
      },
      (error) => {
        fetchTotemReportsError(error, dispatch)
      }
    )
    .finally(() => dispatch(hideSpinner()))
}

export const fetchTotemReportsRequest = () => ({
  type: FETCH_TOTEM_REPORTS_REQUEST,
})

export const fetchTotemReportsSuccess = (data, dispatch) => {
  dispatch(reportsSuccess(data))
}

const reportsSuccess = (data) => ({
  type: FETCH_TOTEM_REPORTS_SUCCESS,
  payload: data,
})

export const fetchTotemReportsError = (error, dispatch) => {
  dispatch(reportsError(error))
  dispatch(hideSpinner())
}

export const reportsError = (error) => ({
  type: FETCH_TOTEM_REPORTS_ERROR,
  payload: error,
})
